export default __webpack_public_path__ + "images/set/led-blur-mask.png";